import React from "react";
// import DealLogo from '../assets/CEL_NCC_Logo.png'
import DealLogoRoyal from '../assets/RCI_Brand_Logo_2-Line_Horiz_Navy_RGB.png';

const CruiseDealCard =(props)=> {
    return(
        <>
        <div className="Cruise-Deal-Card">
            <img src={props.img} alt="Cruise Deals" />

            <div className="cruise-journey-details">
            <p>{props.Destination}</p>  
            <h4>{props.Offer}</h4>
            <img className="Brandlogo" src={DealLogoRoyal} alt="Deal Tirun" />
            <h6>{props.Ship}</h6>               
            </div>
            <a href={props.link} ><button>VIEW ITINERARIES</button></a>
        </div>
        
        </>
    );
}


export default CruiseDealCard ;
